function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { V1View } from '@intercom/interblocks.ts';
export default class IfElseStatementView {
  constructor(node, config) {
    _defineProperty(this, "dom", void 0);
    _defineProperty(this, "view", void 0);
    this.dom = document.createElement('div');
    let innerDom = document.createElement('div');
    this.dom.appendChild(innerDom);
    this.dom.classList.add('embercom-prosemirror-composer-if-else-statement-block');
    let isTemplated = true;
    this.view = new V1View(innerDom, isTemplated, config.templating?.resolver);
    let fallbackIsNotEmpty = node.attrs.fallbackBlocks.length > 0;
    let blocksToRender = fallbackIsNotEmpty ? node.attrs.fallbackBlocks : node.attrs.predicatesBlocksPairs[0].blocks;
    try {
      this.view.render(blocksToRender);
    } catch (e) {
      console.log(e);
    }
  }
}